export class invoice {
    public paymentSuccess: boolean=false;
    public invoiceGenerated: boolean = false;
    public InvoicePath: string = "";
  }
  